import {
  SqliteClient,
  layerMemory
} from "../chunk-C4KMPB4F.mjs";
import {
  SqlExport
} from "../chunk-7SK45QTI.mjs";
import "../chunk-IEP6GGEX.mjs";

// src/platform/browser.ts
import * as Effect from "effect/Effect";
import * as Layer from "effect/Layer";
var sqlExportLayer = Layer.effect(SqlExport, Effect.gen(function* () {
  const sql = yield* SqliteClient;
  return {
    export: sql.export
  };
}));
var layerMemory2 = sqlExportLayer.pipe(Layer.provideMerge(layerMemory({})));
var layerFile = (_filename) => {
  throw new Error("layerFile is not available in browser. Use OPFS worker for persistent storage.");
};
export {
  layerFile,
  layerMemory2 as layerMemory,
  sqlExportLayer
};
//# sourceMappingURL=browser.mjs.map
